import React from 'react';
import { usePaymentTimer, formatTime } from '../../hooks/usePaymentTimer';

const PaymentDetails = ({ paymentData, onSelectChain, onCancel }) => {
  // ✅ CHANGE: Use custom hook instead of useState + useEffect
  const timeRemaining = usePaymentTimer(paymentData?.expiresAt);

  // Helper to truncate addresses as per your original code
  const truncateAddress = (address, chars = 4) => {
    if (!address) return "";
    return `${address.substring(0, chars)}...${address.substring(address.length - chars)}`;
  };

  if (!paymentData) return null;

  return (
    <div className="payment-details">
      <h2 className="section-title">Payment Details</h2>

      {/* Timer with requested clock icon and original logic */}
      <div className={timeRemaining < 30000 ? 'timer timer-warning' : 'timer'}>
        <span style={{ marginRight: '8px' }}>⏰</span>
        <span>Time Remaining: </span>
        <span className="timer-value">{formatTime(timeRemaining)}</span>
      </div>

      <div className="info-card">
        <div className="info-row">
          <span className="info-label">Merchant:</span>
          <span className="info-value">{paymentData.tokenName}</span>
        </div>

        <div className="info-row">
          <span className="info-label">Amount:</span>
          <span className="info-value info-highlight">
          {parseFloat(paymentData.fiatAmount).toFixed(2)} {paymentData.fiatCurrency}
          </span>
        </div>

        <div className="info-row">
          <span className="info-label">Crypto Amount:</span>
          <span className="info-value">
            {paymentData.cryptoAmount} {paymentData.genericToken}
          </span>
        </div>

        <div className="info-row">
          <span className="info-label">Exchange Rate:</span>
          <span className="info-value info-small">
            1 {paymentData.genericToken} = {parseFloat(paymentData.conversionRate).toFixed(2)} {paymentData.fiatCurrency}
          </span>
        </div>

        <div className="info-row">
          <span className="info-label">Merchant Wallet:</span>
          <span className="info-value info-monospace">
            {truncateAddress(paymentData.merchantWallet, 6)}
          </span>
        </div>
      </div>


      <div className="status-indicator success">
        <strong>Available Networks</strong><br/>
          This payment can be made from {paymentData.availableChains.length} networks: {paymentData.availableChains.map(c => c.name).join(', ')}
      </div>





      <div className="actions">
        <button onClick={onSelectChain} className="btn btn-primary btn-lg">
          Select Network
        </button>
        <button onClick={onCancel} className="btn btn-secondary">
          Cancel
        </button>
      </div>
    </div>
  );
};

export default PaymentDetails;